/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';
import { getApplicationConfig } from '../../settings';
import { getMfeName } from './contextHelpers';
import { getSafeContext } from './safeContext';
import { getSafeError } from './safeError';
/**
 * @param name - The name of the error. Must be in PascalCase, e.g. "ViewRenderError".
 * @param err - The error object to log.
 * @param context - The context to log.
 * @returns void
 */
export const error = (name, err, context) => {
    const safeError = getSafeError(err);
    safeError.name = name;
    const safeContext = getSafeContext(safeError, context);
    const isDevelopment = getApplicationConfig()?.WEBUI_ENV_NAME === 'local';
    if (isDevelopment) {
        const mfeName = getMfeName(context);
        console.error(`[${mfeName}]`, safeError);
        return;
    }
    try {
        datadogRum.addError(safeError, safeContext);
    }
    catch (datadogError) {
        console.warn('[Logger] Failed to log error to Datadog. Falling back to console.error.', {
            datadogError,
        });
        console.error(safeError);
    }
};
